import type { JSONB } from '@risksmart-app/domain/src/types/common.types';
import type { ParentType as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { ContentText } from 'pdfmake/interfaces';

import { useLazyGetFormConfigurationByParentType } from '@/hooks/queries';

import { getCustomAttributeDataForExport } from './getCustomAttributeDataForExport';

const useCustomAttributeDataForExport = <
  T extends {
    CustomAttributeData?: JSONB | null;
  },
>(
  parentType: Parent_Type_Enum
): [(item: T) => Promise<(ContentText | string)[]>, boolean] => {
  const [getSchema, getSchemasResult] =
    useLazyGetFormConfigurationByParentType();

  return [
    async (item: T) => {
      const { data: schemaData } = await getSchema({
        parentTypes: [parentType],
      });

      return getCustomAttributeDataForExport(
        item,
        schemaData?.form_configuration?.[0]?.customAttributeSchema
      );
    },
    getSchemasResult.loading,
  ];
};
export default useCustomAttributeDataForExport;
